/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContainerAPISchema
 */
export interface ContainerAPISchema {
    /**
     * 
     * @type {number}
     * @memberof ContainerAPISchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof ContainerAPISchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContainerAPISchema
     */
    updated: Date;
    /**
     * 
     * @type {string}
     * @memberof ContainerAPISchema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerAPISchema
     */
    image: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ContainerAPISchema
     */
    exposedUserPorts?: Array<number>;
}

/**
 * Check if a given object implements the ContainerAPISchema interface.
 */
export function instanceOfContainerAPISchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "image" in value;

    return isInstance;
}

export function ContainerAPISchemaFromJSON(json: any): ContainerAPISchema {
    return ContainerAPISchemaFromJSONTyped(json, false);
}

export function ContainerAPISchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContainerAPISchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'name': json['name'],
        'image': json['image'],
        'exposedUserPorts': !exists(json, 'exposed_user_ports') ? undefined : json['exposed_user_ports'],
    };
}

export function ContainerAPISchemaToJSON(value?: ContainerAPISchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'name': value.name,
        'image': value.image,
        'exposed_user_ports': value.exposedUserPorts,
    };
}

